import { Component, OnInit } from '@angular/core';

import {LanguageService} from '../../language/language.service';
import {Meta, Title} from "@angular/platform-browser";

@Component({
  selector: 'app-big-data',
  templateUrl: './big-data.component.html',
  styleUrls: ['../pages.scss','./big-data.component.scss']
})
export class BigDataComponent implements OnInit {

  constructor(
    private meta: Meta,
    private titleService: Title,
    public languageService: LanguageService
  ) { }

  ngOnInit(): void {
    this.titleService.setTitle(this.languageService.getLang('big data title', 'seo'));
    this.meta.updateTag({
      name: 'description',
      content: this.languageService.getLang('big data desc', 'seo')
    });
  }
}
